import { environment } from "./environments/environment";
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import { initFederation } from "@angular-architects/native-federation";


initFederation(`assets/manifests/${environment.remoteAccess}`)
  .catch(err => console.error(err))
  .then(_ => import('./bootstrap'))
  .catch(err => console.error(err));

localStorage.setItem('part', 'sahanest');